<template>
    <div>
        <model-export-item v-for="export_type in export_types" :key="export_type"
            :export_type="export_type"
            :model="model"
            :files="files"
        ></model-export-item>
        <model-calibration-download
            :model="model"
            :files="files"
            @calibration-ready="$emit('calibration-ready')"
        ></model-calibration-download>
    </div>
</template>

<script>

import ModelExportItem from "@/components/models/ModelExportItem";
import ModelCalibrationDownload from "@/components/models/ModelCalibrationDownload";
import { exportTypesForModel } from "@/utils/modelExportTypes";
import { buildModelFiles } from "@/utils/modelFiles";

export default {
    name: "ModelExports",
    components: {ModelExportItem, ModelCalibrationDownload},
    props: {
        model: {required: true}
    },
    computed: {
        export_types() {
            return exportTypesForModel(this.model);
        },
        filenames() {
            return this.files.map(file=>{return file.name});
        },
        files () {
            const projectId = this.$store.getters['user/get_current_project_id'];
            const token = localStorage.token;
            return buildModelFiles(this.model, projectId, token).allFiles;
        },
    },
    methods: {
    }
}
</script>

<style scoped>

</style>
